export const SET_RESERVATION_NUMBER = 'SET_RESERVATION_NUMBER'
export const RESET_RESERVATION_NUMBER = 'RESET_RESERVATION_NUMBER'
